module.exports = __webpack_public_path__ + "static/img/products application_pool2.75bff967.jpg";